const mes_tab_data = [
  {
    id: 0,
    section: "planning",
    title: "Planiranje",
    path: "/mes/planning",
    subItems: [
      { title: "Timeline", path: "/mes/planning" },
      { title: "Starter plan", path: "/mes/starter-plan" },
      { title: "Osoblje", path: "/mes/staff" },
    ],
  },
  {
    id: 1,
    section: "execution",
    title: "Izvrsavanje",
    path: "/mes/work-orders",
    subItems: [
      { title: "Radni nalozi", path: "/mes/work-orders" },
      { title: "Nalozi proizvodnje", path: "/mes/production-work-orders" },
      { title: "Radni nalozi (tablet)", path: "/mes/work-orders-tablet" },
      { title: "Procesni podaci", path: "/mes/process-data" },
    ],
  },
  {
    id: 2,
    section: "development",
    title: "Razvoj",
    path: "/mes/trials",
    subItems: [
      { title: "Nova proba", path: "/mes/trials/new" },
      { title: "Spremljene probe", path: "/mes/saved-trials" },
      { title: "Dashboard", path: "/mes/trial-dashboard" },
    ],
  },
  {
    id: 8,
    section: "lab",
    title: "Laboratorij",
    path: "/mes/labos/mjerenja",
    subItems: [
      { title: "Labos nalozi", path: "/mes/labos/nalozi" },
      { title: "Labos mjerenja", path: "/mes/labos/mjerenja" },
    ],
  },
  {
    id: 3,
    section: "warehouse",
    title: "Skladiste",
    path: "/mes/receive-delivery",
    subItems: [
      { title: "Primke", path: "/mes/receive-delivery" },
      { title: "Međuskladišnice", path: "/mes/inter-warehouse-transfers" },
      { title: "Stanje po skladištu", path: "/mes/stock-by-warehouse" },
      { title: "Inventura", path: "/mes/inventura" },
      { title: "Gotovi proizvodi", path: "/mes/finished-goods" },
      { title: "LOT-ovi", path: "/mes/stock-overview" },
      { title: "Otpremnice", path: "/mes/dispatch" },
      { title: "Sljedivost", path: "/mes/traceability" },
    ],
  },
  {
    id: 4,
    section: "quality",
    title: "Kvaliteta",
    path: "/mes/flour-analyses",
    subItems: [
      { title: "Red čekanja", path: "/mes/flour-analyses" },
      { title: "Povijest testiranih", path: "/mes/flour-analyses/history" },
    ],
  },
  {
    id: 5,
    section: "monitoring",
    title: "Pracenje",
    path: "/mes/monitoring",
    subItems: [
      { title: "Dashboard", path: "/mes/monitoring" },
      { title: "KPI", path: "/mes/kpi" },
      { title: "Batchevi", path: "/mes/batches" },
    ],
  },
  {
    id: 6,
    section: "finance",
    title: "Financije",
    path: "/mes/ingredient-prices",
    subItems: [
      { title: "Cijene sirovina", path: "/mes/ingredient-prices" },
      { title: "Troskovi proizvoda", path: "/mes/product-costs" },
    ],
  },
  {
    id: 7,
    section: "database",
    title: "Baza",
    path: "/mes/products",
    subItems: [
      { title: "Proizvodi", path: "/mes/products" },
      { title: "Recepti", path: "/mes/recipes" },
      { title: "Sirovine", path: "/mes/ingredients" },
      { title: "Poluproizvodi", path: "/mes/semi-finished" },
      { title: "Strojevi", path: "/mes/machines" },
    ],
  },
  {
    id: 9,
    section: "procurement",
    title: "Nabava",
    path: "/mes/order-requests",
    subItems: [
      { title: "Zahtjev za narudžbu", path: "/mes/order-requests" },
    ],
  },
  {
    id: 10,
    section: "overview",
    title: "Pregled",
    path: "/mes/overview",
    subItems: [
      { title: "Registar dokumenata", path: "/mes/overview" },
    ],
  },
  {
    id: 11,
    section: "reports",
    title: "Izvjestaji",
    path: "/mes/reports",
    subItems: [
      { title: "Dnevni izvještaj", path: "/mes/reports" },
    ],
  },
];

export default mes_tab_data;
